import { addVideo, searchYouTube } from '@services/youtube';
import { saveRegistrationData } from "@services/indexdb";
import { obterDataAtual } from './helpers';
import emitter from '@services/emitter';
import { YouTubePlaylist } from '@interfaces/Playlist';

export const addVideoToPlaylist = async (database: string, { videoId, username }: YouTubePlaylist) => {
    try {
        const videoID = await searchYouTube(videoId);
        const data = await addVideo(videoID, username)
        await saveRegistrationData(database, { ...{ id: obterDataAtual("AA:MM:DD:hh:mm:ss") }, ...data });
        console.log('aqui')
        emitter.emit("playlistUpdate", data);
        // Clear the input fields
        // username = '';
        // id = '';
    } catch (error) {
        console.error(error)
    }
}




